// extracted by mini-css-extract-plugin
module.exports = {"sponsor":"HomeComponent_sponsor__1Kd4o"};